import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import AnimatedLoader from '../../components/animated-loader';
import { getCount } from '../../selectors/location-history-selectors';
import { isSeoViewMode } from '../../services/wix-sdk-utils';

const isServer = typeof window === 'undefined';

class MasonryWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isContentVisible: !props.isEnabled || (!isServer && props.historyEntryCount > 1) || isSeoViewMode(),
    };
  }

  componentDidMount() {
    this.setState({ isContentVisible: true });
  }

  render() {
    return (
      <AnimatedLoader shouldShowLoader={false} isLoading={!this.state.isContentVisible}>
        {this.props.children}
      </AnimatedLoader>
    );
  }
}

MasonryWrapper.propTypes = {
  historyEntryCount: PropTypes.number.isRequired,
  children: PropTypes.node,
  isEnabled: PropTypes.bool,
};

const mapStateToProps = state => ({
  historyEntryCount: getCount(state),
});

export default connect(mapStateToProps)(MasonryWrapper);



// WEBPACK FOOTER //
// ./app/components/masonry-wrapper/masonry-wrapper.js